import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { confirmValidation } from '../../infrastructure/api/validation.api';

const Validation = () => {
  const [searchParams] = useSearchParams();
  const navigation = useNavigate();

  const confirm = async () => {
    const kind = searchParams.get('kind');
    const code = searchParams.get('code');
    const response = await confirmValidation({ code, kind });
    if (response.status !== 200) return;
    navigation('/?message="You have successfully created your account!"');
  };

  useEffect(() => {
    confirm();
  }, []);

  return <></>;
};

export default Validation;
